import React, { Component } from 'react'; 
import PersonalPaymentPopup from '../modules/popup/PersonalPaymentPopup';

class PersonalPaymentPage extends Component {
  render() {
    return (
      <div id='page-wrapper' className="container" style={{backgroundColor: '#ffffff', display: "flex", flexDirection: "column", minHeight: "100vh", justifyContent: "center"}}>
        <div style={{marginBottom: "39px"}}>
            <PersonalPaymentPopup
                isPopup={true}
                // isClose={true}
            />
        </div>
      </div>
    );
  }
}

export default PersonalPaymentPage;